import React from 'react';

import { usePageStore } from '@client/store/pageStore/context/pageContext';
import { SpectrogramPoint } from '@ledium/types';
import { WavelengthChart } from '@ledium/ui-common';
import { Grid } from '@mui/material';

import { MixerSettings } from './SpectrumMixerChannelSettingsItem';

const SpectrumMixerChart = () => {
    const {
        pageState: { formData }
    } = usePageStore();
    const lightChannels = formData.lightChannels as unknown[];
    const settings = formData.settings as MixerSettings;
    const aggregatedSpectrogram = formData.aggregatedSpectrogram as SpectrogramPoint[];

    return (
        <>
            {lightChannels.length || formData.lightRecipe ? (
                <Grid item xs={12} md={8}>
                    {(aggregatedSpectrogram && aggregatedSpectrogram.length) || formData.lightRecipe ? (
                        <WavelengthChart unit={settings.intensityUnit} data={aggregatedSpectrogram} showLegend={true} />
                    ) : null}
                </Grid>
            ) : null}
        </>
    );
};

export default React.memo(SpectrumMixerChart);
